<template>
  <div class="app-wrapper">
    <div class="router-wrapper">
      <router-view/>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from './components/Footer.vue'
export default {
  components: {
    Footer
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Noto+Sans|Roboto+Slab&display=swap');

:root {
  --head-font: 'Roboto Slab', serif;
  --body-font: 'Noto Sans', serif;
  --text-color: #1a1919;
  --bg-color: #f2f2f2;
  --blue: #108ad1;
  font-size: 15px;
  font-family: var(--body-font);
  background-color: var(--bg-color);
  color: var(--text-color);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: var(--head-font);
  margin: 0;
}

p {
  margin: 0;
}

a {
  color: inherit;
  text-decoration: none;
}

ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

li {
  padding: 0;
}

button,
input {
  font-family: inherit;
  color: inherit;
}

.container {
  max-width: 1220px;
  padding: 0 10px;
  margin: 0 auto;
}

.router-wrapper {
  min-height: calc(100vh -  34px);
}
.data-table {
  width: 100%;
  border-spacing: 0;
  margin-bottom: 20px;
}

.tf-button {
  padding: 8px 15px;
  border-radius: 3px;
  background-color: #0e9bea;
  border: 1px solid #0e9bea;
  cursor: pointer;
  color: #fff;
  font-size: 16px;
  display: inline-block;

  &:hover {
    background-color: var(--blue);
  }

  &:disabled {
    background-color: #ddd;
    border-color: currentColor;
  }

  &--secondary {
    background-color: transparent;
    color: #555;
    border: 1px solid currentColor;

    &:hover {
      background-color: #555;
      border-color: #555;
      color: #fff;
    }
  }
}


td, th {
  text-align: left;
  padding: 10px 15px;
}

th {
  font-weight: 400;
  font-size: 14px;
  color: #888;
  white-space: nowrap;
}

.IRON::before,
.BRONZE::before,
.SILVER::before,
.GOLD::before,
.PLATINUM::before,
.DIAMOND::before,
.MASTER::before,
.GRANDMASTER::before,
.CHALLENGER::before,
.summoner__unranked::before {
  content: '';
  display: inline-block;
  width: 25px;
  height: 25px;
  vertical-align: middle;
  background-size:contain;
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 10px;
}

.IRON::before {background-image: url(./assets/images/ranked-emblems/Emblem_Iron.png)}
.BRONZE::before {background-image: url(./assets/images/ranked-emblems/Emblem_Bronze.png)}
.SILVER::before {background-image: url(./assets/images/ranked-emblems/Emblem_Silver.png)}
.GOLD::before {background-image: url(./assets/images/ranked-emblems/Emblem_Gold.png)}
.PLATINUM::before {background-image: url(./assets/images/ranked-emblems/Emblem_Platinum.png)}
.DIAMOND::before {background-image: url(./assets/images/ranked-emblems/Emblem_Diamond.png)}
.MASTER::before {background-image: url(./assets/images/ranked-emblems/Emblem_Master.png)}
.GRANDMASTER::before {background-image: url(./assets/images/ranked-emblems/Emblem_Grandmaster.png)}
.CHALLENGER::before {background-image: url(./assets/images/ranked-emblems/Emblem_Challenger.png)}

.tf-button--narrow {
  padding-top: 4px;
  padding-bottom: 4px;
}

</style>
